import { render, staticRenderFns } from "./flexible-countdown.vue?vue&type=template&id=182d5a64&scoped=true&lang=pug&"
import script from "./flexible-countdown.vue?vue&type=script&lang=js&"
export * from "./flexible-countdown.vue?vue&type=script&lang=js&"
import style0 from "./flexible-countdown.vue?vue&type=style&index=0&id=182d5a64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182d5a64",
  null
  
)

export default component.exports